<div class="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center sticky">
  <img ngSrc="assets/logo.webp" alt="QuickDrive Logo" class="w-24" width="100" height="35" />
  <form
    [formGroup]="authRegisterForm"
    class="w-full p-4 rounded-lg form-container"
    (ngSubmit)="handleSubmit()"
  >
    <div>
      <ion-input
        #input
        [autocomplete]="'given-name'"
        type="text"
        label="Vorname"
        errorText="Vorname wird benötigt"
        label-placement="floating"
        formControlName="forename"
        id="forename"
        placeholder="Vorname"
        required
      ></ion-input>
    </div>
    <div>
      <ion-input
        #input
        [autocomplete]="'family-name'"
        label="Nachname"
        errorText="Nachname wird benötigt"
        label-placement="floating"
        formControlName="surname"
        id="surname"
        placeholder="Nachname"
        required
      ></ion-input>
    </div>
    <div>
      <ion-input
        #input
        [autocomplete]="'email'"
        label="Deine E-Mail"
        helperText="Bitte gib eine gültige E-Mail Adresse ein."
        errorText="E-Mail Adresse ungültig"
        label-placement="floating"
        type="email"
        formControlName="email"
        id="email"
        placeholder="name@quickdrive.ch"
        required
      ></ion-input>
    </div>
    <div>
      <ion-input
        clearOnEdit="true"
        autocomplete="off"
        label="Dein Passwort"
        helperText="Mindestens 6 Zeichen, mindestens eine Zahl und ein Buchstabe"
        [errorText]="getPasswordErrorText()"
        label-placement="floating"
        type="password"
        formControlName="password"
        id="password"
        required
      >
        <ion-input-password-toggle slot="end"></ion-input-password-toggle>
      </ion-input>
    </div>
    <div>
      <ion-input
        clearOnEdit="true"
        autocomplete="off"
        label="Wiederhole dein Passwort"
        helperText="Muss mit deinem Passwort übereinstimmen"
        [errorText]="getRepeatPasswordErrorText()"
        label-placement="floating"
        type="password"
        formControlName="repeatPassword"
        id="repeatPassword"
        required
      >
        <ion-input-password-toggle slot="end"></ion-input-password-toggle>
      </ion-input>
    </div>
    <ion-button mode="ios" class="mt-6" expand="block" type="submit" [disabled]="loading()"
      ><ion-label class="flex items-center gap-4"> @if (loading()) {<ion-spinner></ion-spinner>} Registrieren</ion-label></ion-button
    >
  </form>

  <p class="mt-10 text-center text-sm text-gray-500">
    Bereits registriert?
    <a
      href=""
      class="font-semibold leading-6 text-quickdrive hover:text-blue-800"
      (click)="handleChange($event)"
      >Login</a
    >
  </p>
</div>
